import React from 'react';
import { ChatContext } from './chatbot';
import axios from 'axios';
const queryString = require('query-string');

function getTutorClasses(){
  var myParam = {
      email: localStorage.getItem('email')
  }

  axios.post("https://auxilliabackend.herokuapp.com/getTutorClasses",myParam)
  .then(function (response) {
    const classList = response.data;
    let i;
    for (i = 0; i < classList.length; ++i) {
      console.log(classList[i]);
    }
    localStorage.setItem('classSelection', classList);
    return classList;
  })
  .catch(function (error) {
  console.log(error);
  });
}

function LoginForm() {
  const chatData  = React.useContext(ChatContext);
  const userInput = React.useRef();
  const [error, setError] = React.useState(false);
  const login = (ev) => {
    if (ev.type === 'keyup' && ev.key !== 'Enter') {
      return;
    }
    
    setError(false);
    const params = queryString.parse(window.location.search).class;//gets class
    console.log(localStorage.getItem('email'));
    console.log(params);
    var classnames;
    if (localStorage.getItem("mode") == "tutor") {
      getTutorClasses();
      classnames = localStorage.getItem('classSelection').split(",");
      let i;
      for (i = 0; i < classnames.length; ++i) {
        console.log(classnames[i]);
      }
    } else {
      classnames = localStorage.getItem('classSelection');
    }
    chatData.login(localStorage.getItem('email'), classnames).catch(() => setError(true));
    //chatData.login(localstorage.identifier, localstorage.classcode).catch...again
    //might have to distinguish between student and tutor in this file as well so that you know where to pull from local storage for login function
  }
  const logout = () => chatData.logout();

  if (chatData.user.username === null) {
    return (
      <div id="login">
        <div>
          {/* <input type="text" ref={userInput} onKeyUp={login} autoFocus /> */}
          &nbsp;
          <button style={{height: "50px", width: "200px", fontSize: "40px", border: "none", border_radius: "20px"}} onClick={login}>Start Chat</button>
          {error && <>&nbsp;Login error, please try again.</>}
        </div>
      </div>
    );
  }
  else {
    return (
      <div style={{color:"white"}}id="login">
        <div>
          Username: <b>{ chatData.user.username }</b>&nbsp;
          <button style={{height: "20px", width: "100px", fontSize: "20px", border: "none", border_radius: "20px"}} onClick={logout}>Exit Chat</button>
        </div>
      </div>
    );
  }
}

export default LoginForm;
